/**
 * Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.
 */

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

var LeafletService = require('../services/leaflet.service');


import '../librairies/leaflet/leaflet.css'
import './wraper-map.css';

var WraperMap = CreateReactClass({
    propTypes : {

    },
    defaultProps : {

    },
    componentDidMount() {
        //LeafletService.default.createMap()
    },
    shouldComponentUpdate() {
        return false;
    },
    render: function () {

        return (
            <div id="map">
            </div>
        )
    }
});

module.exports = WraperMap;


// http://stackoverflow.com/questions/26755251/good-way-to-combine-react-and-leaflet
// var Livemap = React.createClass({
//     componentDidMount: function() {
//         var map = this.map = L.map(ReactDOM.findDOMNode(this), {
//             minZoom: 2,
//             maxZoom: 20,
//             layers: [
//                 L.tileLayer(
//                     'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
//                     {attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'})
//             ],
//             attributionControl: false,
//         });
//
//         map.on('click', this.onMapClick);
//         map.fitWorld();
//     },
//     componentWillUnmount: function() {
//         this.map.off('click', this.onMapClick);
//         this.map = null;
//     },
//     onMapClick: function() {
//         // Do some wonderful map things...
//     },
//     render: function() {
//         return (
//             <div id='map'></div>
//         );
//     }
// });


// WEBPACK FOOTER //
// ./src/components/wraper-map.js